/**
 * Warmth Filter Dropdown
 * Handles the UI behavior for the warmth rating dropdown filter
 */

document.addEventListener('DOMContentLoaded', function() {
  const dropdown = document.querySelector('#warmth-rating-filter');
  if (!dropdown) return;

  const dropdownBtn = dropdown.querySelector('.warmth-dropdown-btn');
  const dropdownMenu = dropdown.querySelector('.warmth-dropdown-menu');

  // Toggle dropdown
  dropdownBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    const isOpen = dropdownBtn.getAttribute('aria-expanded') === 'true';

    dropdownBtn.setAttribute('aria-expanded', !isOpen);
    dropdownMenu.setAttribute('aria-hidden', isOpen);
    dropdownMenu.hidden = isOpen;

    if (!isOpen) {
      dropdownMenu.classList.add('visible');
    } else {
      dropdownMenu.classList.remove('visible');
    }
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function(event) {
    if (!dropdown.contains(event.target)) {
      dropdownBtn.setAttribute('aria-expanded', 'false');
      dropdownMenu.setAttribute('aria-hidden', 'true');
      dropdownMenu.hidden = true;
      dropdownMenu.classList.remove('visible');
    }
  });

  // Prevent dropdown from closing when clicking inside
  dropdownMenu.addEventListener('click', function(e) {
    e.stopPropagation();
  });
});